<template>
    <svg class="snippet-circle" ref="svg" viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg">
    </svg>
</template>

<script>
    import { 
        select as d3Select,
        selectAll as d3SelectAll,
    } from 'd3';

    export default {
        name: 'Snippets',
        props: ['data'],
        computed: {
            yPos() {
                // console.log(this.data.pos[0]);
                let nodeCourse = d3Select(`rect#id-${this.data.pos[0]}`)
                if (nodeCourse.node() != null) {
                    return nodeCourse;
                }
            }
        },
        methods: {
            setPos() {
                

                // let nodeCourse = d3Select(`rect#id-${this.snippetCurrent.pos[0]}`);
                // let nodeYear = d3Select(`text#id-${this.snippetCurrent.pos[1]}`);

                // if (nodeCourse.node() != null && nodeYear.node()) {

                //     let course = nodeCourse.node().getBoundingClientRect();
                //     let year = nodeYear.node().getBoundingClientRect();
    
                //     this.distToTop = parseFloat(course.y) - this.radius;
                //     this.distToLeft = parseFloat(year.x) - this.radius;
            }
        },
        mounted() {
            // console.log(this.yPos);
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .snippet-circle {
        fill: black;
    }
</style>